var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_13897084",
    width: 20,
    height: 20,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m182.276 487.825c0 13.33 10.845 24.175 24.175 24.175h276.071c13.33 0 24.175-10.845 24.175-24.175v-20.595h-324.421z",
    fill: "#8BA4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.453 318.095h-93.933c-63.546 0-115.244 51.698-115.244 115.244v3.979h324.421v-3.979c0-63.546-51.698-115.244-115.244-115.244z",
    fill: "#8BA4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.03 227.523c14.321-6.882 27.101-16.779 37.426-29.138v-145.491l-37.426-12.299z",
    fill: "#8BA4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.276 433.339c0-80.088 65.156-145.244 145.244-145.244h71.401l14.409-87.502h-67.622c-25.787 42.172-71.494 68.004-121.392 68.004s-95.605-25.832-121.392-68.004h-67.621l51.281 311.407h101.874c-3.94-7.507-6.182-16.038-6.182-25.088z",
    fill: "#8BA4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.456 117.313h37.426v53.279h-37.426z",
    fill: "#8BA4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.317 238.597c6.341 0 12.595-.537 18.713-1.563v-237.034h-37.426v237.034c6.118 1.026 12.371 1.563 18.713 1.563z",
    fill: "#8BA4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.751 100.607h37.426v69.985h-37.426z",
    fill: "#8BA4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.178 198.386c10.325 12.359 23.105 22.255 37.426 29.138v-186.929l-37.426 12.299z",
    fill: "#8BA4BF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastFood);
export default __webpack_public_path__ + "static/media/Fast-food.e114f91052731e309f2ee3f7ed6e9e70.svg";
export { ForwardRef as ReactComponent };